<template>
  <section class="page">
    <div class="page-header">
      <div class="page-header-start">
        <ModalAddCompany v-if="modalClick" @CloseModal="modalClick = false" />
        <h3 class="page-title">All Company</h3>
        <div class="button-group">
          <button class="button primary small" @click="modalClick = true">
            <i class="fad fa-plus"></i>Add
          </button>
        </div>
      </div>
      <div class="page-header-end">
        <p class="datepicker">
          <span class="label">Select Month</span>
          <span>
            <date-picker v-model="monthYear" type="month" valueType="format" placeholder="YYYY/MM"></date-picker></span>
        </p>

        <div class="button-group">
          <button @click="downloadTemplate()" :class="['button small primary', { 'is-loading': isLoading }]">
            <i class="fad fa-file-excel"></i>Download
          </button>
          <button @click="downloadCompany()" :class="['button small primary', { 'is-loading': loading }]">
            <i class="fad fa-file-excel"></i>Download All Company
          </button>
        </div>
      </div>
    </div>
    <div class="tabs-container">
      <div class="tabs">
        <div class="tabs-start">
          <router-link :to="{
          query: {
            type: 'All',
            p: $route.query.p,
            q: $route.query.q,
            s: $route.query.s,
          },
        }" class="tab">All</router-link>
          <router-link :to="{
          query: {
            type: 'Yellowlist',
            p: $route.query.p,
            q: $route.query.q,
            s: $route.query.s,
          },
        }" class="tab">Yellow list</router-link>
          <router-link :to="{
          query: {
            type: 'Approved',
            p: $route.query.p,
            q: $route.query.q,
            s: $route.query.s,
          },
        }" class="tab">Approved</router-link>
          <router-link :to="{
          query: {
            type: 'Hiring',
            p: $route.query.p,
            q: $route.query.q,
            s: $route.query.s,
          },
        }" class="tab">Hiring</router-link>
          <router-link :to="{
          query: {
            type: 'Featured',
            p: $route.query.p,
            q: $route.query.q,
            s: $route.query.s,
          },
        }" class="tab">Featured</router-link>
          <router-link :to="{
          query: {
            type: 'Pending',
            p: $route.query.p,
            q: $route.query.q,
            s: $route.query.s,
          },
        }" class="tab">Pending</router-link>

          <router-link :to="{
          query: {
            type: 'Rejected',
            p: $route.query.p,
            q: $route.query.q,
            s: $route.query.s,
          },
        }" class="tab">Rejected</router-link>
        </div>
        <div class="tabs-end">
          <div class="search control">
            <input type="text" class="input" v-model="searchJobs" placeholder="Search...." required @keyup="search" />
          </div>
        </div>
      </div>
    </div>
    <CompanyList />
  </section>
</template>

<script>
import ModalAddCompany from "@coms/company-setup/addCompany.vue";
import CompanyList from "../components/company/company-list";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import axios from "axios";
export default {
  components: {
    CompanyList,
    ModalAddCompany,
    DatePicker,
  },
  data: () => ({
    searchJobs: "",
    modalClick: false,
    monthYear: "",
    isLoading: false,
    loading: false,
  }),
  methods: {
    search() {
      this.$router
        .push({
          name: this.$router.name,
          query: {
            type: this.$route.query.type,
            p: "10",
            q: "1",
            s: this.searchJobs,
          },
        })
        .catch(() => { });
    },
    async downloadTemplate() {
      try {
        if (!this.monthYear) return alert("Please select month");
        this.isLoading = true;
        const monthYear = moment(this.monthYear).format("YYYY-MM");
        await this.$store.dispatch("loading");
        axios.defaults.headers["Authorization"] = this.$store.getters.Token;
        const res = await axios.get(
          `${process.env.VUE_APP_HTTPS_ADMIN}/api/report-group-view-employer?month=${monthYear}`,
          {
            responseType: "blob",
          }
        );
        const url = URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Activity-Company-View.xlsx");
        document.body.appendChild(link);
        link.click();
        this.isLoading = false;
        await this.$store.dispatch("completed");
      } catch (err) {
        await this.$store.dispatch("error");
        throw new Error(err);
      }
    },
    async downloadCompany() {
      try {

        if (!this.monthYear) return alert("Please select month");
        this.loading = true;
        const monthYear = moment(this.monthYear).format("YYYY-MM");
        await this.$store.dispatch("loading");
        axios.defaults.headers["Authorization"] = this.$store.getters.Token;
        const res = await axios.get(
          `${process.env.VUE_APP_HTTPS_ADMIN}/api/export-compay-list?date=${monthYear}`,
          {
            responseType: "blob",
          }
        );
        const url = URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "employerList.xlsx");
        document.body.appendChild(link);
        link.click();
        this.loading = false;
        await this.$store.dispatch("completed");
      } catch (err) {
        await this.$store.dispatch("error");
        throw new Error(err);
      }
    },
  },
  watch: {},
  created() {
    this.search();
  },
};
</script>
<style lang="scss" scoped>
// .page-header-end {
//   margin-left: auto;
//   display: flex;
//   align-items: center;

//   ul {
//     list-style-type: none;
//     margin: 0;
//     display: flex;
//     align-items: center;

//     li {
//       display: flex;
//       align-items: center;
//       margin: 0;
//       padding: 0%;
//       flex-grow: 1;
//       margin-left: 10px;

//       span {
//         display: block;
//         flex-grow: 1;

//         &:first-child {
//           margin-right: 10px;
//         }

//         input.input {
//           font-size: var(--md-font);
//           padding: 0 10px;
//           background-color: #fff;
//           border: none;
//         }
//       }
//     }
//   }
// }</style>
